import React from 'react';
import styles from './Field.module.css';
import {Field, useField} from 'formik';

const FieldCustom = ({ label, type, name, placeholder, id = name, onChange, onKeyDown }) => {
    const [field, meta, helpers] = useField(name);

    const handleChange = (e) => {
        field.onChange(e);
        if (onChange) onChange(e);
    };

    return (
        <div className={`${styles.field} ${styles[type]}`}>
            <label htmlFor={id}>{label}</label>
            <Field
                type={type}
                id={id}
                name={name}
                placeholder={placeholder}
                onChange={onChange ? handleChange : field.onChange}
                onKeyDown={onKeyDown}
                style={meta.error && meta.touched ? { borderColor: "var(--clr-error)" } : null}
            />
            {meta.touched && meta.error ? <div className={"error"} style={{ color: "var(--clr-error)", fontSize: "var(--fs-secondary)"}}>{meta.error}</div> : null}
        </div>
    );
};

export default FieldCustom;
